import type { RiskEvent } from '../../models';

/**
 * 解析事件风控状态码：优先 event.risk_status，兼容首单 event_status。
 * @param event - 风险事件
 * @returns 0 待确认 / 1 已忽略 / 2 已解决；无法解析时为 0
 */
export function resolveEventRiskStatus(event: RiskEvent): number {
    const raw = event.risk_status ?? event.orders?.[0]?.event_status;
    if (raw === undefined || raw === null) return 0;
    const n = Number(raw);
    return Number.isNaN(n) ? 0 : n;
}
